// Dependencies
import Vue from 'vue'

// Modules
import store from './vuex/store'
import router from './router'

// Components
import App from './App'

// Load config
Vue.config.holidays = process.env

/* eslint-disable no-new */
new Vue({
  store,
  router,
  el: Vue.config.holidays.ROOT_ELEM,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js